import React, { useState, useEffect } from "react";
import ScoreInitModal from "./ScoreInitModal";
import { TennisScoreEngine } from "./TennisScoreEngine";
import { refs } from "./data/refs";
import { refFormatSet } from "./data/refs";
import './components/NewMatchPage.css';
import './App.css';
import { saveMatch, updateMatch } from './services/matchService';
import { incrementMatchCount } from './services/profileService';
import { searchPlayers, createPlayer, linkPlayerToUser, findSimilarPlayers, getPlayerById, updatePlayerRanking } from './services/playersService';
import DuplicatePlayersModal from './components/DuplicatePlayersModal';
import RankingUpdateModal from './components/RankingUpdateModal';


function NewMatchPage({ currentUser, onCancel, onMatchCreated, currentMatch }) {
  console.log("🚨 NEW MATCH PAGE CHARGÉE !");
  console.log("🔍 refs:", refs);
  console.log("🔍 refs.refSurface:", refs?.refSurface);
  console.log("🔍 refs.refTour:", refs?.refTour);
  console.log("🔍 refs.refCategorieAge:", refs?.refCategorieAge);
  console.log("🔍 currentMatch reçu:", currentMatch);
  console.log("👤 currentUser reçu:", currentUser);

  const [isEditMode, setIsEditMode] = useState(false);
  const [showScoreInitModal, setShowScoreInitModal] = useState(false);
  const [scoreInitConfig, setScoreInitConfig] = useState(null);

  // 🆕 États pour la liaison joueurs
  const [player1Id, setPlayer1Id] = useState(null);
  const [player2Id, setPlayer2Id] = useState(null);
  const [player1Search, setPlayer1Search] = useState('');
  const [player2Search, setPlayer2Search] = useState('');
  const [player1Results, setPlayer1Results] = useState([]);
  const [player2Results, setPlayer2Results] = useState([]);
  const [player1Selected, setPlayer1Selected] = useState(null);
  const [player2Selected, setPlayer2Selected] = useState(null);
  const [dupDialog, setDupDialog] = useState(null);
  const [rankDialog, setRankDialog] = useState(null);

  const [form, setForm] = useState({
    dateMatch: new Date().toISOString().slice(0, 10),
    tournoiNom: "",
    surface: "",
    categorie: "",
    tour: "",
    categorieage: "",
    epreuve: "",
    joueur1Nom: "",
    prenomJoueur1: "",
    joueur1Droitier: "",
    joueur1Club: "",
    classementJ1: "",
    paysJ1: "",
    joueur2Nom: "",
    prenomJoueur2: "",
    joueur2Droitier: "",
    joueur2Club: "",
    classementJ2: "",
    paysJ2: "",
    formatMatch: "BEST_OF_3",
    toss: "",
    premierServeur: "",
    formatSet1Code: "STD",
    formatSet2Code: "STD",
    formatSet3Code: "STD",
    formatSet4Code: "STD",
    formatSet5Code: "T10",
  });

  useEffect(() => {
    if (currentMatch) {
      setIsEditMode(true);
      // Conserver la liaison avec les fiches joueurs existantes
      console.log('🔗 Liaisons joueurs du match:', currentMatch.player1Id, currentMatch.player2Id);
      setPlayer1Id(currentMatch.player1Id || null);
      setPlayer2Id(currentMatch.player2Id || null);
      setForm({
        dateMatch: currentMatch.dateMatch || '',
        tournoiNom: currentMatch.tournoiNom || '',
        surface: (currentMatch.surfaceCode || '').trim(),
        categorie: (currentMatch.categorieCode || '').trim(),
        tour: (currentMatch.tourCode || '').trim(),
        categorieage: (currentMatch.categorieageCode || '').trim(),
        epreuve: (currentMatch.epreuveCode || '').trim(),
        joueur1Nom: currentMatch.joueur1Nom || '',
        prenomJoueur1: currentMatch.prenomJoueur1 || '',
        joueur1Droitier: currentMatch.joueur1Droitier !== undefined ? String(currentMatch.joueur1Droitier) : '',
        joueur1Club: currentMatch.joueur1Club || '',
        classementJ1: (currentMatch.joueur1ClassementCode || '').trim(),
        paysJ1: (currentMatch.joueur1PaysCode || '').trim(),
        joueur2Nom: currentMatch.joueur2Nom || '',
        prenomJoueur2: currentMatch.prenomJoueur2 || '',
        joueur2Droitier: currentMatch.joueur2Droitier !== undefined ? String(currentMatch.joueur2Droitier) : '',
        joueur2Club: currentMatch.joueur2Club || '',
        classementJ2: (currentMatch.joueur2ClassementCode || '').trim(),
        paysJ2: (currentMatch.joueur2PaysCode || '').trim(),
        formatMatch: currentMatch.formatMatch || 'BEST_OF_3',
        toss: currentMatch.toss || '',
        premierServeur: currentMatch.premierServeur || '',
        formatSet1Code: currentMatch.formatSet1Code || 'STD',
        formatSet2Code: currentMatch.formatSet2Code || 'STD',
        formatSet3Code: currentMatch.formatSet3Code || 'STD',
        formatSet4Code: currentMatch.formatSet4Code || 'STD',
        formatSet5Code: currentMatch.formatSet5Code || 'T10',
      });
    }
  }, [currentMatch]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    const matchId = isEditMode ? (currentMatch.id || currentMatch.matchId) : null;

    // 🆕 Vérifier si le premierServeur a changé et s'il y a des points joués
    if (isEditMode) {
      const savedMatchData = JSON.parse(localStorage.getItem(`match_${matchId}`) || '{}');
      const hasPoints = (savedMatchData.engineState?.points?.length || 0) > 0;
      const serveurAChange = form.premierServeur !== currentMatch.premierServeur;

      if (hasPoints && serveurAChange) {
        const confirmer = window.confirm(
          `⚠️ Attention\n\n` +
          `Vous modifiez le premier serveur alors que ${savedMatchData.engineState.points.length} point(s) ont déjà été enregistré(s).\n\n` +
          `Cette modification peut rendre les statistiques de service/retour incohérentes pour les points déjà joués.\n\n` +
          `Voulez-vous continuer quand même ?`
        );
        if (!confirmer) return;
      }
    }

    const matchInput = {
      ...(matchId && { id: matchId }),
      userId: currentUser.id,
      matchId: currentMatch?.matchId || matchId,
      dateMatch: form.dateMatch,
      tournoiNom: form.tournoiNom,
      surfaceCode: form.surface,
      categorieCode: form.categorie,
      tourCode: form.tour,
      categorieageCode: form.categorieage,
      epreuveCode: form.epreuve,
      joueur1Nom: form.joueur1Nom,
      prenomJoueur1: form.prenomJoueur1,
      joueur1Club: form.joueur1Club,
      joueur1ClassementCode: form.classementJ1,
      joueur1PaysCode: form.paysJ1,
      joueur1Droitier: form.joueur1Droitier === "true",
      joueur2Nom: form.joueur2Nom,
      prenomJoueur2: form.prenomJoueur2,
      joueur2Club: form.joueur2Club,
      joueur2ClassementCode: form.classementJ2,
      joueur2PaysCode: form.paysJ2,
      joueur2Droitier: form.joueur2Droitier === "true",
      player1Id: player1Id || null,
      player2Id: player2Id || null,
      formatMatch: form.formatMatch,
      toss: form.toss,
      premierServeur: form.premierServeur,
      formatSet1Code: form.formatSet1Code,
      formatSet2Code: form.formatSet2Code,
      formatSet3Code: form.formatSet3Code,
      formatSet4Code: form.formatSet4Code,
      formatSet5Code: form.formatSet5Code,
      status: currentMatch?.status || 'DRAFT',
      // 🆕 Lire depuis le localStorage local (source de vérité pour les points et le score)
      currentScore: (() => {
        // En mode création (matchId=null), pas de localStorage à lire
        if (!matchId) {
          // Si score initial saisi, l'utiliser
          if (scoreInitConfig) {
            const sets = scoreInitConfig.sets || [];
            const jeuJ1 = scoreInitConfig.jeuScore?.[0] || 0;
            const jeuJ2 = scoreInitConfig.jeuScore?.[1] || 0;
            const jeuScore = `${jeuJ1}-${jeuJ2}`;
            return {
              jeuScore,
              sets: [...sets.map(s => [...s]), [jeuJ1, jeuJ2]],
              server: scoreInitConfig.server || form.premierServeur || 'J1',
              scoreInitConfig,  // gardé pour initialiser le moteur au démarrage
            };
          }
          return { jeuScore: "0-0", sets: [[0, 0]], server: form.premierServeur || 'J1' };
        }
        const savedData = JSON.parse(localStorage.getItem(`match_${matchId}`) || '{}');
        // const hasPoints = (savedData.engineState?.points?.length || 0) > 0;
        // Prendre le currentScore depuis le localStorage local en priorité
        const existingScore = savedData.currentScore || currentMatch?.currentScore || { jeuScore: "0-0", sets: [[0, 0]] };
        // Toujours forcer le server avec le nouveau premierServeur
        // (que des points aient été joués ou non)
        return {
          ...existingScore,
          server: form.premierServeur || 'J1'
        };
      })(),
      // 🆕 Préserver l'engineState local s'il a plus de points que le cloud
      engineState: (() => {
        // En mode création (matchId=null), créer un état initial
        if (!matchId) {
          return {
            points: [],
            currentSet: 0,
            sets: [[0, 0]],
            jeuPoints: [0, 0],
            server: form.premierServeur || 'J1',
            tieBreakActive: false,
            superTieBreakActive: false,
            tieBreakPoints: [0, 0],
            matchFinished: false,
            lastTieBreakScores: [],
            tieBreakFirstServer: null
          };
        }
        const savedData = JSON.parse(localStorage.getItem(`match_${matchId}`) || '{}');
        const localPoints = savedData.engineState?.points?.length || 0;
        const matchPoints = currentMatch?.engineState?.points?.length || 0;
        if (localPoints > matchPoints) {
          // Le local a plus de points → le préserver
          return savedData.engineState;
        }
        // Sinon utiliser celui du match ou créer un état initial
        return currentMatch?.engineState || {
          points: [],
          currentSet: 0,
          sets: [[0, 0]],
          jeuPoints: [0, 0],
          server: form.premierServeur || 'J1',
          tieBreakActive: false,
          superTieBreakActive: false,
          tieBreakPoints: [0, 0],
          matchFinished: false,
          lastTieBreakScores: [],
          tieBreakFirstServer: null
        };
      })(),
      matchComments: currentMatch?.matchComments || null
    };

    console.log("💾 DEBUG SAUVEGARDE:", { 
      id: matchId, 
      isEditMode,
      tournoiNom: matchInput.tournoiNom,
      surfaceCode: matchInput.surfaceCode,
      userId: matchInput.userId,
      currentUserId: currentUser?.id
    });

    // 🆕 Créer automatiquement les fiches joueurs si nécessaire
    const { p1Id, p2Id, cancelled } = await autoCreatePlayers();
    if (cancelled) return; // l'utilisateur a annulé : on reste sur le formulaire

    // 🏆 Classement différent de celui de la fiche : proposer la mise à jour
    await handleRankingUpdates(p1Id, p2Id);
    if (p1Id) matchInput.player1Id = p1Id;
    if (p2Id) matchInput.player2Id = p2Id;

    try {
      let result;
      
      if (isEditMode) {
        result = await updateMatch(matchInput);
        
        if (result.offline) {
          alert('⚠️ Match modifié localement\n(Sera synchronisé quand vous aurez Internet)');
        } else if (result.online) {
          console.log('✅ Match modifié avec succès');
        }
      } else {
        result = await saveMatch(matchInput);
        
        if (result.offline) {
          alert('⚠️ Match sauvegardé localement\n(Sera synchronisé quand vous aurez Internet)');
        } else if (result.online) {
          console.log('✅ Match créé avec succès');
        }
        
        await incrementMatchCount(currentUser.id);
      }

      const finalMatch = result.data || matchInput;
      const finalMatchId = finalMatch.id;
      
      if (!finalMatchId) {
        throw new Error('Pas d\'ID retourné par la sauvegarde');
      }

      if (!finalMatch.matchId) {
        finalMatch.matchId = finalMatchId;
      }

      const savedMatchData = JSON.parse(localStorage.getItem(`match_${finalMatchId}`) || '{}');

      // Si un score initial a été saisi, initialiser le moteur et sauvegarder son état
      let engineStateToSave = savedMatchData.engineState || null;
      let currentScoreToSave = finalMatch.currentScore;

      if (scoreInitConfig) {
        const matchFormats = [
          finalMatch.formatSet1Code || "STD",
          finalMatch.formatSet2Code || "STD",
          finalMatch.formatSet3Code || "STD",
          finalMatch.formatSet4Code || "NON",
          finalMatch.formatSet5Code || "NON",
        ];
        const tempEngine = new TennisScoreEngine({
          matchFormats,
          formatMatch: finalMatch.formatMatch || "BEST_OF_3",
          premierServeur: finalMatch.premierServeur || "J1"
        });
        const configWithTb = { ...scoreInitConfig };
        if (scoreInitConfig.setsTb) configWithTb.lastTieBreakScores = scoreInitConfig.setsTb;
        tempEngine.initializeFromScore(configWithTb);
        engineStateToSave = tempEngine.saveState();
        currentScoreToSave = tempEngine.getCurrentScore();
        console.log('⚡ EngineState initialisé depuis scoreInitConfig:', currentScoreToSave.jeuScore);
      }

      localStorage.setItem(`match_${finalMatchId}`, JSON.stringify({
        ...savedMatchData,
        pointForm: savedMatchData.pointForm || {
          familleCode: "SVC",
          sousTypeCode: "1S",
          nbFrappesCode: "3",
        },
        pointsCount: savedMatchData.pointsCount || 0,
        ...finalMatch,
        currentScore: currentScoreToSave,
        engineState: engineStateToSave || finalMatch.engineState,
      }));

      console.log("💾 SAUVEGARDÉ avec UUID:", finalMatchId);
      onMatchCreated(finalMatch, isEditMode);
      
    } catch (error) {
      console.error("❌ Erreur sauvegarde:", error);
      alert('❌ Erreur lors de la sauvegarde du match');
    }
  };

  // 🆕 Recherche joueur 1 avec debounce
  React.useEffect(() => {
    if (!player1Search || player1Search.length < 2) { setPlayer1Results([]); return; }
    const t = setTimeout(async () => {
      const r = await searchPlayers(player1Search);
      if (r.success) setPlayer1Results(r.players);
    }, 350);
    return () => clearTimeout(t);
  }, [player1Search]);

  // 🆕 Recherche joueur 2 avec debounce
  React.useEffect(() => {
    if (!player2Search || player2Search.length < 2) { setPlayer2Results([]); return; }
    const t = setTimeout(async () => {
      const r = await searchPlayers(player2Search);
      if (r.success) setPlayer2Results(r.players);
    }, 350);
    return () => clearTimeout(t);
  }, [player2Search]);

  const show5Sets = form.formatMatch === "BEST_OF_5";

  // Cherche d'abord par CODE (ex. 40 = 15/5), puis par libellé : un libellé peut ressembler
  // à un autre code (le libellé "40" a pour code 12), donc le code doit toujours primer.
  const findClassement = (v) => {
    const x = String(v == null ? '' : v).trim();
    if (!x) return undefined;
    return refs.refClassement.find(c => c.code === x) || refs.refClassement.find(c => c.labelFr === x);
  };

  // 🆕 Sélectionner un joueur depuis les résultats
  const selectPlayer = (num, player) => {
    if (num === 1) {
      setPlayer1Id(player.id);
      setPlayer1Selected(player);
      setPlayer1Search('');
      setPlayer1Results([]);
      // Convertir label classement → code numérique si nécessaire
      const cl1 = findClassement(player.dernierClassementCode);
      setForm(f => ({
        ...f,
        joueur1Nom: player.nom || '',
        prenomJoueur1: player.prenom || '',
        joueur1Club: player.dernierClub || f.joueur1Club,
        classementJ1: cl1?.code || f.classementJ1,
        paysJ1: player.paysCode || f.paysJ1,
        joueur1Droitier: player.mainDominante === 'Droitier' ? 'true' : player.mainDominante === 'Gaucher' ? 'false' : f.joueur1Droitier,
      }));
    } else {
      setPlayer2Id(player.id);
      setPlayer2Selected(player);
      setPlayer2Search('');
      setPlayer2Results([]);
      const cl2 = findClassement(player.dernierClassementCode);
      setForm(f => ({
        ...f,
        joueur2Nom: player.nom || '',
        prenomJoueur2: player.prenom || '',
        joueur2Club: player.dernierClub || f.joueur2Club,
        classementJ2: cl2?.code || f.classementJ2,
        paysJ2: player.paysCode || f.paysJ2,
        joueur2Droitier: player.mainDominante === 'Droitier' ? 'true' : player.mainDominante === 'Gaucher' ? 'false' : f.joueur2Droitier,
      }));
    }
  };

  // 🆕 Désélectionner un joueur lié
  const clearPlayer = (num) => {
    if (num === 1) {
      setPlayer1Id(null);
      setPlayer1Selected(null);
      setForm(f => ({ ...f, joueur1Nom: '', prenomJoueur1: '', joueur1Club: '', classementJ1: '', paysJ1: '', joueur1Droitier: '' }));
    } else {
      setPlayer2Id(null);
      setPlayer2Selected(null);
      setForm(f => ({ ...f, joueur2Nom: '', prenomJoueur2: '', joueur2Club: '', classementJ2: '', paysJ2: '', joueur2Droitier: '' }));
    }
  };

  // 🆕 Créer automatiquement les fiches joueurs si nom renseigné et pas encore lié
  // Détection de doublons : propose d'utiliser un joueur similaire déjà existant
  // Retourne : { type: 'none' } | { type: 'use', id } | { type: 'create' } | { type: 'cancel' }
  const askUseSimilarPlayer = async (nom, prenom) => {
    const r = await findSimilarPlayers(nom, prenom);
    if (!r.success || r.players.length === 0) return { type: 'none' };
    return new Promise((resolve) => {
      setDupDialog({
        candidates: r.players,
        searched: { nom, prenom },
        onUse: (player) => { setDupDialog(null); resolve({ type: 'use', id: player.id }); },
        onCreateNew: () => { setDupDialog(null); resolve({ type: 'create' }); },
        onCancel: () => { setDupDialog(null); resolve({ type: 'cancel' }); },
      });
    });
  };

  // 🏆 Classement saisi différent de celui de la fiche joueur → proposer la mise à jour
  const classementLabelOf = (code) => {
    const f = refs.refClassement.find(c => c.code === String(code || '').trim());
    return f ? f.labelFr : (code || '');
  };

  const handleRankingUpdates = async (p1Id, p2Id) => {
    try {
      const date = form.dateMatch || new Date().toISOString().slice(0, 10);
      const toAsk = [];

      for (const n of ['1', '2']) {
        const id = n === '1' ? p1Id : p2Id;
        const code = String(form['classementJ' + n] || '').trim();
        if (!id || !code) continue;
        // En modification : on ne propose que si le classement du match a réellement changé
        if (isEditMode && currentMatch && code === String(currentMatch['joueur' + n + 'ClassementCode'] || '').trim()) continue;

        const r = await getPlayerById(id);
        if (!r.success || !r.player) continue;
        const pl = r.player;
        const oldCode = String(pl.dernierClassementCode || '').trim();
        if (oldCode === code) continue;

        const club = form['joueur' + n + 'Club'] || null;
        const fresh = !pl.dateMajClassement || date >= String(pl.dateMajClassement).slice(0, 10);

        // Fiche sans classement, ou information plus ancienne que la fiche : pas de question
        if (!fresh || !oldCode) {
          await updatePlayerRanking(id, { classementCode: code, club, date, source: 'match' });
          continue;
        }

        toAsk.push({
          key: n, id, code, club,
          name: [form['prenomJoueur' + n], form['joueur' + n + 'Nom']].filter(Boolean).join(' ') || ('Joueur ' + n),
          oldLabel: classementLabelOf(oldCode),
          newLabel: classementLabelOf(code),
        });
      }

      if (toAsk.length === 0) return;

      const chosen = await new Promise((resolve) => {
        setRankDialog({
          changes: toAsk.map(c => ({ key: c.key, name: c.name, oldLabel: c.oldLabel, newLabel: c.newLabel })),
          onConfirm: (keys) => { setRankDialog(null); resolve(keys); },
          onSkip: () => { setRankDialog(null); resolve([]); },
        });
      });

      for (const c of toAsk) {
        if (chosen.includes(c.key)) {
          await updatePlayerRanking(c.id, { classementCode: c.code, club: c.club, date, source: 'match' });
        }
      }
    } catch (err) {
      console.warn('⚠️ handleRankingUpdates:', err.message);
    }
  };

  // En modification : si le nom du joueur n'a pas changé, on ne cherche pas de doublon
  const norm = (v) => String(v || '').trim().toLowerCase();
  const playerUnchanged = (n) => isEditMode && currentMatch &&
    norm(form['joueur' + n + 'Nom']) === norm(currentMatch['joueur' + n + 'Nom']) &&
    norm(form['prenomJoueur' + n]) === norm(currentMatch['prenomJoueur' + n]);

  const autoCreatePlayers = async () => {
    try {
      let p1Id = player1Id;
      let p2Id = player2Id;

      const needsCheck = (n, id) =>
        !id && !playerUnchanged(n) && (form['joueur' + n + 'Nom'] || form['prenomJoueur' + n]);

      // 1. Décisions pour les 2 joueurs AVANT toute création
      let d1 = { type: 'none' };
      let d2 = { type: 'none' };
      if (needsCheck('1', p1Id)) {
        d1 = await askUseSimilarPlayer(form.joueur1Nom, form.prenomJoueur1);
        if (d1.type === 'cancel') return { cancelled: true };
      }
      if (needsCheck('2', p2Id)) {
        d2 = await askUseSimilarPlayer(form.joueur2Nom, form.prenomJoueur2);
        if (d2.type === 'cancel') return { cancelled: true };
      }

      // 2. Application des décisions
      const resolvePlayer = async (n, id, d) => {
        if (d.type === 'use') {
          await linkPlayerToUser(d.id).catch(() => {});
          return d.id;
        }
        if (needsCheck(n, id)) {
          const r = await createPlayer({
            nom: form['joueur' + n + 'Nom'],
            prenom: form['prenomJoueur' + n],
            dernierClub: form['joueur' + n + 'Club'] || null,
            dernierClassementCode: form['classementJ' + n] || null,
            paysCode: form['paysJ' + n] || null,
            mainDominante: form['joueur' + n + 'Droitier'] === 'true' ? 'Droitier' : form['joueur' + n + 'Droitier'] === 'false' ? 'Gaucher' : null,
          });
          return r.success ? r.player.id : id;
        }
        if (id) await linkPlayerToUser(id).catch(() => {});
        return id;
      };

      p1Id = await resolvePlayer('1', p1Id, d1);
      p2Id = await resolvePlayer('2', p2Id, d2);

      return { p1Id, p2Id };
    } catch (err) {
      console.warn('⚠️ autoCreatePlayers:', err.message);
      return { p1Id: player1Id, p2Id: player2Id };
    }
  };

  return (
    <div style={{ padding: "24px", fontFamily: "Arial, sans-serif" }}>
      {dupDialog && <DuplicatePlayersModal {...dupDialog} />}
      {rankDialog && <RankingUpdateModal {...rankDialog} />}
      <h2 className="tt-newmatch-title">
        {isEditMode ? '✏️ Modifier match' : '➕ Nouveau match'}
      </h2>

      <form
        onSubmit={handleSubmit}
        style={{
          maxWidth: "800px",
          backgroundColor: "var(--bg-secondary)",
          padding: "16px 20px",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        {/* Infos générales */}
        <h3 className="tt-section-title">Infos générales</h3>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "6px 24px",
            marginBottom: "16px",
          }}
        >
          <div>
            <label style={{ fontWeight: "bold", display: "block" }}>
              Date du match
            </label>
            <input
              type="date"
              name="dateMatch"
              value={form.dateMatch}
              onChange={handleChange}
              className="tt-field"
            />
          </div>
          <div>
            <label style={{ fontWeight: "bold", display: "block" }}>
              Tournoi
            </label>
            <input
              type="text"
              name="tournoiNom"
              value={form.tournoiNom}
              onChange={handleChange}
              className="tt-field"
              placeholder="Nom du tournoi"
            />
          </div>

          <div>
            <label style={{ fontWeight: "bold", display: "block" }}>
              Surface
            </label>
            <select 
              name="surface" 
              value={form.surface || ""} 
              onChange={handleChange} 
              className="tt-field">
              <option value="">Sélectionner ...</option>
              {refs.refSurface.map((surface) => (
                <option key={surface.code} value={surface.code}>
                  {surface.labelFr}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label style={{ fontWeight: "bold", display: "block" }}>
              Catégorie tournoi
            </label>
            <select 
              name="categorie" 
              value={form.categorie || ""} 
              onChange={handleChange} 
              className="tt-field">
              <option value="">Sélectionner ...</option>
              {refs.refCategorie.map((cat) => (
                <option key={cat.code} value={cat.code}>
                  {cat.labelFr}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label style={{ fontWeight: "bold", display: "block" }}>
              Tour
            </label>
            <select 
              name="tour" 
              value={form.tour || ""} 
              onChange={handleChange} 
              className="tt-field">
              <option value="">Sélectionner ...</option>
              {refs.refTour.map((tour) => (
                <option key={tour.code} value={tour.code}>
                  {tour.labelFr}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label style={{ fontWeight: "bold", display: "block" }}>
              Catégorie Age
            </label>
            <select 
              name="categorieage" 
              value={form.categorieage || ""} 
              onChange={handleChange} 
              className="tt-field">
              <option value="">Sélectionner ...</option>
              {refs.refCategorieAge.map((cat) => (
                <option key={cat.code} value={cat.code}>
                  {cat.labelFr}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label style={{ fontWeight: "bold", display: "block" }}>
              Épreuve
            </label>
            <select 
              name="epreuve" 
              value={form.epreuve || ""} 
              onChange={handleChange} 
              className="tt-field">
              <option value="">Sélectionner ...</option>
              {refs.refEpreuve.map((epreuve) => (
                <option key={epreuve.code} value={epreuve.code}>
                  {epreuve.labelFr}
                </option>
              ))}
          </select>
          </div>

          <div>
            <label style={{ fontWeight: "bold", display: "block" }} className="tt-required">
              Format de match
            </label>
            <select
              name="formatMatch"
              value={form.formatMatch}
              onChange={handleChange}
              className="tt-field" required
            >
              <option value="BEST_OF_3">2 sets gagnants</option>
              <option value="BEST_OF_5">3 sets gagnants</option>
            </select>
          </div>

          <div>
            <label style={{ fontWeight: "bold", display: "block" }}>
              Vainqueur Toss
            </label>
            <select 
              name="toss"
              value={form.toss || ""} 
              onChange={handleChange}
              className="tt-field" 
            >
              <option value="">Sélectionner...</option>
              {[
                {code: "J1", libelle: "Toss J1"},
                {code: "J2", libelle: "Toss J2"},
              ].map(opt => (
                <option key={opt.code} value={opt.code}>{opt.libelle}</option>
              ))}
            </select>
          </div>

          <div>
            <label style={{ fontWeight: "bold", display: "block" }} className="tt-required">
              1er Serveur
            </label>
            <select 
              name="premierServeur"
              value={form.premierServeur || ""} 
              onChange={handleChange}
              className="tt-field" required
            >
              <option value="">Sélectionner...</option>
              {[
                {code: "J1", libelle: "J1 sert"},
                {code: "J2", libelle: "J2 sert"},
              ].map(opt => (
                <option key={opt.code} value={opt.code}>{opt.libelle}</option>
              ))}
            </select>
          </div>

        </div>

        {/* Joueurs */}
        <h3 className="tt-section-title">Joueurs</h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "6px 24px",
            marginBottom: "16px",
          }}
        >
          <div>
            <label style={{ fontWeight: "bold", display: "block" }}>
              Joueur 1
            </label>
            {/* 🆕 Recherche joueur existant */}
            {!player1Selected ? (
              <div style={{ position: 'relative', marginBottom: '4px' }}>
                <input
                  type="text"
                  value={player1Search}
                  onChange={e => setPlayer1Search(e.target.value)}
                  className="tt-field"
                  placeholder="🔍 Rechercher un joueur existant..."
                  style={{ marginBottom: 0 }}
                />
                {player1Results.length > 0 && (
                  <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '8px', zIndex: 100, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', maxHeight: '200px', overflowY: 'auto' }}>
                    {player1Results.map(p => (
                      <div
                        key={p.id}
                        onClick={() => selectPlayer(1, p)}
                        style={{ padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', fontSize: '13px' }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = 'white'}
                      >
                        <strong>{[p.prenom, p.nom].filter(Boolean).join(' ')}</strong>
                        {p.dernierClassementCode && <span style={{ color: '#999', marginLeft: '8px' }}>{(refs.refClassement.find(c => c.code === String(p.dernierClassementCode).trim()) || {}).labelFr || p.dernierClassementCode}</span>}
                        {p.dernierClub && <span style={{ color: '#999', marginLeft: '8px' }}>· {p.dernierClub}</span>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', padding: '6px 10px', backgroundColor: '#e3f2fd', borderRadius: '6px' }}>
                <span style={{ fontSize: '13px', color: '#1976d2', flex: 1 }}>
                  ✓ {[player1Selected.prenom, player1Selected.nom].filter(Boolean).join(' ')}
                </span>
                <button type="button" onClick={() => clearPlayer(1)} style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: '16px' }}>×</button>
              </div>
            )}
            <input
              type="text"
              name="joueur1Nom"
              value={form.joueur1Nom}
              onChange={handleChange}  
              className="tt-field"
              placeholder="Nom du joueur 1"
            />
            <input
              type="text"
              name="prenomJoueur1"
              value={form.prenomJoueur1}
              onChange={handleChange}  
              className="tt-field"
              placeholder="Prénom du joueur 1"
            />
            <select 
              name="joueur1Droitier" 
              value={form.joueur1Droitier}
              onChange={(e) => setForm(prev => ({ ...prev, joueur1Droitier: e.target.value }))}
              className="tt-field"
              required={process.env.REACT_APP_ENV === 'development'}
            >
              <option value="">Sélectionner...</option>
              <option value="true">🎾 Droitier</option>
              <option value="false">🎾 Gaucher</option>
            </select>
            <input
              type="text"
              name="joueur1Club"
              value={form.joueur1Club}
              onChange={handleChange}
              className="tt-field"
              placeholder="Club"
            />
            <select 
              name="classementJ1" 
              value={form.classementJ1 || ""} 
              onChange={handleChange}
              className="tt-field"
            >
              <option value="">Classement J1</option>
              {refs.refClassement.map((cl) => (
                <option key={cl.code} value={cl.code}> 
                  {cl.labelFr}
                </option>
              ))}
            </select>
            <select 
              name="paysJ1" 
              value={form.paysJ1 || ""} 
              onChange={handleChange}
              className="tt-field"
            >
              <option value="">Pays J1</option>
              {refs.refPays.map((pays) => (
                <option key={pays.code} value={pays.code}> 
                  {pays.labelFr}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label style={{ fontWeight: "bold", display: "block" }}>
              Joueur 2
            </label>
            {/* 🆕 Recherche joueur existant */}
            {!player2Selected ? (
              <div style={{ position: 'relative', marginBottom: '4px' }}>
                <input
                  type="text"
                  value={player2Search}
                  onChange={e => setPlayer2Search(e.target.value)}
                  className="tt-field"
                  placeholder="🔍 Rechercher un joueur existant..."
                  style={{ marginBottom: 0 }}
                />
                {player2Results.length > 0 && (
                  <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '8px', zIndex: 100, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', maxHeight: '200px', overflowY: 'auto' }}>
                    {player2Results.map(p => (
                      <div
                        key={p.id}
                        onClick={() => selectPlayer(2, p)}
                        style={{ padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', fontSize: '13px' }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = 'white'}
                      >
                        <strong>{[p.prenom, p.nom].filter(Boolean).join(' ')}</strong>
                        {p.dernierClassementCode && <span style={{ color: '#999', marginLeft: '8px' }}>{(refs.refClassement.find(c => c.code === String(p.dernierClassementCode).trim()) || {}).labelFr || p.dernierClassementCode}</span>}
                        {p.dernierClub && <span style={{ color: '#999', marginLeft: '8px' }}>· {p.dernierClub}</span>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', padding: '6px 10px', backgroundColor: '#e3f2fd', borderRadius: '6px' }}>
                <span style={{ fontSize: '13px', color: '#1976d2', flex: 1 }}>
                  ✓ {[player2Selected.prenom, player2Selected.nom].filter(Boolean).join(' ')}
                </span>
                <button type="button" onClick={() => clearPlayer(2)} style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: '16px' }}>×</button>
              </div>
            )}
            <input
              type="text"
              name="joueur2Nom"
              value={form.joueur2Nom}
              onChange={handleChange}
              className="tt-field"
              placeholder="Nom du joueur 2"
            />
            <input
              type="text"
              name="prenomJoueur2"
              value={form.prenomJoueur2}
              onChange={handleChange}
              className="tt-field"
              placeholder="Prénom du joueur 2"
            />
            <select 
              name="joueur2Droitier" 
              value={form.joueur2Droitier}
              onChange={(e) => setForm(prev => ({ ...prev, joueur2Droitier: e.target.value }))}
              className="tt-field"
              required={process.env.REACT_APP_ENV === 'development'}
            >
              <option value="">Sélectionner...</option>
              <option value="true">🎾 Droitier</option>
              <option value="false">🎾 Gaucher</option>
            </select>
            <input
              type="text"
              name="joueur2Club"
              value={form.joueur2Club}
              onChange={handleChange}
              className="tt-field"
              placeholder="Club"
            />
            <select 
              name="classementJ2" 
              value={form.classementJ2 || ""} 
              onChange={handleChange}
              className="tt-field"
            >
              <option value="">Classement J2</option>
              {refs.refClassement.map((cl) => (
                <option key={cl.code} value={cl.code}> 
                  {cl.labelFr}
                </option>
              ))}
            </select>
            <select 
              name="paysJ2" 
              value={form.paysJ2 || ""} 
              onChange={handleChange}
              className="tt-field"
            >
              <option value="">Pays J2</option>
              {refs.refPays.map((pays) => (
                <option key={pays.code} value={pays.code}> 
                  {pays.labelFr}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Formats de set */}
        <h3 className="tt-section-title">Formats de set</h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "6px 16px",
            marginBottom: "16px",
          }}
        >
          <div>
            <label style={{ fontWeight: "bold", display: "block" }} className="tt-required">
              Set 1
            </label>
            <select
              name="formatSet1Code"
              value={form.formatSet1Code}
              onChange={handleChange}
              className="tt-set-field"
              required
            >
              {refFormatSet.map((fs) => (
                <option key={fs.code} value={fs.code}>
                  {fs.labelFr}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label style={{ fontWeight: "bold", display: "block" }} className="tt-required">
              Set 2
            </label>
            <select
              name="formatSet2Code"
              value={form.formatSet2Code}
              onChange={handleChange}
              className="tt-set-field"
              required
            >
              {refFormatSet.map((fs) => (
                <option key={fs.code} value={fs.code}>
                  {fs.labelFr}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label style={{ fontWeight: "bold", display: "block" }} className="tt-required">
              Set 3
            </label>
            <select
              name="formatSet3Code"
              value={form.formatSet3Code}
              onChange={handleChange}
              className="tt-set-field"
              required
            >
              {refFormatSet.map((fs) => (
                <option key={fs.code} value={fs.code}>
                  {fs.labelFr}
                </option>
              ))}
            </select>
          </div>
        </div>

        {show5Sets && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "6px 16px",
              marginBottom: "16px",
            }}
          >
            <div>
              <label style={{ fontWeight: "bold", display: "block" }} className="tt-required">
                Set 4
              </label>
              <select
                name="formatSet4Code"
                value={form.formatSet4Code}
                onChange={handleChange}
                className="tt-set-field"
                required
              >
                {refFormatSet.map((fs) => (
                  <option key={fs.code} value={fs.code}>
                    {fs.labelFr}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label style={{ fontWeight: "bold", display: "block" }} className="tt-required">
                Set 5
              </label>
              <select
                name="formatSet5Code"
                value={form.formatSet5Code}
                onChange={handleChange}
                className="tt-set-field"
                required
              >
                {refFormatSet.map((fs) => (
                  <option key={fs.code} value={fs.code}>
                    {fs.labelFr}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {/* ⚡ Section score initial - seulement en création */}
        {!isEditMode && (
          <div style={{ marginTop: "20px", marginBottom: "8px", textAlign: "center" }}>
            <button
              type="button"
              onClick={() => setShowScoreInitModal(true)}
              style={{
                padding: "10px 20px",
                borderRadius: "10px",
                border: "2px dashed #1976d2",
                backgroundColor: "transparent",
                color: "#1976d2",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "600",
                width: "100%",
              }}
            >
              ⚡ {scoreInitConfig ? "✅ Score initial saisi — modifier" : "Match en cours ? Saisir le score actuel"}
            </button>
          </div>
        )}

        {showScoreInitModal && (
          <ScoreInitModal
            onConfirm={(config) => { setScoreInitConfig(config); setShowScoreInitModal(false); }}
            onClose={() => setShowScoreInitModal(false)}
            formatMatch={form.formatMatch || "BEST_OF_3"}
            premierServeur={form.premierServeur || "J1"}
          />
        )}

        <div style={{ marginTop: "24px", textAlign: "right" }}>
          <button
            type="button"
            onClick={onCancel}
            style={{
              marginRight: "8px",
              padding: "8px 16px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              backgroundColor: "white",
              cursor: "pointer",
            }}
          >
            Annuler
          </button>
          <button
            type="submit"
            style={{
              padding: "8px 16px",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#1976d2",
              color: "white",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            {isEditMode ? "Enregistrer" : "Créer le match"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default NewMatchPage;